import * as types from "../actions/types";

const initialState = {
  list: [],
  loading: false,
  item: {}
};

export default function time_slot(state = initialState, action) {
  switch (action.type) {

    case types.GET_TIME_SLOT_LIST:
      return {
        ...state,
        list: action.payload
      };
      case types.SET_TIME_SLOT_LIST_LOADING:
        return {
          ...state,
          loading: action.payload
        };
      case types.SET_TIME_SLOT_BY_ID:
        return {
          ...state,
          item: action.payload
        };
    default:
      return state;
  }
}